import Mentors from "../Mentors";

const MentorProfilesGrid = () => {
  return (
    <div className="p-5 bg-light">
      <Mentors />
    </div>
  );
};

export default MentorProfilesGrid;
